import { ModuleTypeMeta } from './../../common';

export interface ModuleStation {}

export const ModuleStationMeta: ModuleTypeMeta<ModuleStation> = {
  default: {},
  icon: 'location',
};
